var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10932",
    "data-name": "Group 10932",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91.947,
    height: 106,
    viewBox: "0 0 91.947 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3234",
    "data-name": "Rectangle 3234",
    width: 91.947,
    height: 106,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10931",
    "data-name": "Group 10931",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29457",
    "data-name": "Path 29457",
    d: "M13.659,50.078,51.212,12.525a4.827,4.827,0,0,1,6.8,0l5.242,5.242a4.827,4.827,0,0,1,0,6.8L25.7,62.123,11.25,64.532Z",
    transform: "translate(24.886 24.604)",
    fill: "#96e099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29458",
    "data-name": "Path 29458",
    d: "M48.932,85.068,34.477,87.477l2.409-14.455L68.2,41.7V24.841L44.114.75H.75V101.932H68.2V65.8Z",
    transform: "translate(1.659 1.659)",
    fill: "#ffeee3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3231",
    "data-name": "Rectangle 3231",
    width: 43.364,
    height: 7.227,
    transform: "translate(2.409 2.409)",
    fill: "#fff7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3232",
    "data-name": "Rectangle 3232",
    width: 67.455,
    height: 7.227,
    transform: "translate(2.409 96.364)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29459",
    "data-name": "Path 29459",
    d: "M63.257,14.47,61.4,12.613A4.81,4.81,0,0,1,60.11,17L22.544,54.56,12.066,56.417l-.816,4.818L25.7,58.826,63.257,21.273a4.827,4.827,0,0,0,0-6.8",
    transform: "translate(24.886 27.901)",
    fill: "#7dc97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29460",
    "data-name": "Path 29460",
    d: "M54.35,16.79a4.8,4.8,0,0,1,6.813,0l3.4,3.386a4.814,4.814,0,0,0-1.307-2.409l-5.242-5.242a4.827,4.827,0,0,0-6.8,0L13.659,50.078,11.25,64.532l3.977-.652,1.593-9.636Z",
    transform: "translate(24.886 24.604)",
    fill: "#e3f9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29461",
    "data-name": "Path 29461",
    d: "M14.25.75V24.841H38.341Z",
    transform: "translate(31.523 1.659)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29462",
    "data-name": "Path 29462",
    d: "M3.159,27.75a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V30.159A2.41,2.41,0,0,1,3.159,27.75",
    transform: "translate(1.659 61.386)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29463",
    "data-name": "Path 29463",
    d: "M8.409,28.5a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,1,1-4.818,0V30.909A2.41,2.41,0,0,1,8.409,28.5",
    transform: "translate(13.273 63.045)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29464",
    "data-name": "Path 29464",
    d: "M11.409,29.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V31.659a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(19.909 64.705)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29465",
    "data-name": "Path 29465",
    d: "M20.409,28.5a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,1,1-4.818,0V30.909A2.41,2.41,0,0,1,20.409,28.5",
    transform: "translate(39.818 63.045)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29466",
    "data-name": "Path 29466",
    d: "M4.659,1.5A2.41,2.41,0,0,1,7.068,3.909V8.727a2.409,2.409,0,1,1-4.818,0V3.909A2.41,2.41,0,0,1,4.659,1.5",
    transform: "translate(4.977 3.318)",
    fill: "#fff7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29467",
    "data-name": "Path 29467",
    d: "M7.659,2.25a2.41,2.41,0,0,1,2.409,2.409V9.477a2.409,2.409,0,0,1-4.818,0V4.659A2.41,2.41,0,0,1,7.659,2.25",
    transform: "translate(11.614 4.977)",
    fill: "#fff7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29468",
    "data-name": "Path 29468",
    d: "M12.159.75a2.41,2.41,0,0,1,2.409,2.409V7.977a2.409,2.409,0,1,1-4.818,0V3.159A2.41,2.41,0,0,1,12.159.75",
    transform: "translate(21.568 1.659)",
    fill: "#fff7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29469",
    "data-name": "Path 29469",
    d: "M15.159,1.5a2.41,2.41,0,0,1,2.409,2.409V8.727a2.409,2.409,0,1,1-4.818,0V3.909A2.41,2.41,0,0,1,15.159,1.5",
    transform: "translate(28.205 3.318)",
    fill: "#fff7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29470",
    "data-name": "Path 29470",
    d: "M25.659,15.75a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,1,1-4.818,0V18.159a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(51.432 34.841)",
    fill: "#7dc97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29471",
    "data-name": "Path 29471",
    d: "M25.659,11.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V13.659a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(51.432 24.886)",
    fill: "#e3f9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29472",
    "data-name": "Path 29472",
    d: "M22.659,29.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V31.659a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(44.795 64.705)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3233",
    "data-name": "Rectangle 3233",
    width: 24.091,
    height: 7.227,
    transform: "translate(45.773 26.5)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29473",
    "data-name": "Path 29473",
    d: "M12.93,68.6a2.415,2.415,0,0,1-2.409-2.8L12.93,51.343a2.663,2.663,0,0,1,.678-1.317L51.187,12.483a7.241,7.241,0,0,1,10.215,0l5.233,5.233a7.241,7.241,0,0,1,0,10.215L29.09,65.483a2.539,2.539,0,0,1-1.317.678L13.319,68.57Zm4.654-15.71L15.866,63.25l10.366-1.718,37-37a2.389,2.389,0,0,0,0-3.411L58,15.884a2.389,2.389,0,0,0-3.411,0Z",
    transform: "translate(23.206 22.95)",
    fill: "#583ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29474",
    "data-name": "Path 29474",
    d: "M16.659,8.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V10.659A2.41,2.41,0,0,1,16.659,8.25",
    transform: "translate(31.523 18.25)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29475",
    "data-name": "Path 29475",
    d: "M18.909,9a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,1,1-4.818,0V11.409A2.41,2.41,0,0,1,18.909,9",
    transform: "translate(36.5 19.909)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29476",
    "data-name": "Path 29476",
    d: "M22.659,8.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V10.659A2.41,2.41,0,0,1,22.659,8.25",
    transform: "translate(44.795 18.25)",
    fill: "#ffd6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29477",
    "data-name": "Path 29477",
    d: "M23.409,14.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,1,1-4.818,0V16.659a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(46.455 31.523)",
    fill: "#e3f9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29478",
    "data-name": "Path 29478",
    d: "M18.159,19.5a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V21.909A2.41,2.41,0,0,1,18.159,19.5",
    transform: "translate(34.841 43.136)",
    fill: "#e3f9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29479",
    "data-name": "Path 29479",
    d: "M15.909,24.75a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V27.159a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(29.864 54.75)",
    fill: "#7dc97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29480",
    "data-name": "Path 29480",
    d: "M21.909,18.75a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,1,1-4.818,0V21.159a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(43.136 41.477)",
    fill: "#7dc97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29481",
    "data-name": "Path 29481",
    d: "M19.659,17.25a2.41,2.41,0,0,1,2.409,2.409v4.818a2.409,2.409,0,0,1-4.818,0V19.659a2.41,2.41,0,0,1,2.409-2.409",
    transform: "translate(38.159 38.159)",
    fill: "#e3f9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29482",
    "data-name": "Path 29482",
    d: "M40,28.909H15.909A2.41,2.41,0,0,1,13.5,26.5V2.409A2.4,2.4,0,0,1,14.994.189,2.385,2.385,0,0,1,17.615.7L41.706,24.794A2.417,2.417,0,0,1,40,28.909M18.318,24.09H34.189L18.318,8.219Z",
    transform: "translate(29.864 0.001)",
    fill: "#583ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29483",
    "data-name": "Path 29483",
    d: "M69.864,106H2.409A2.41,2.41,0,0,1,0,103.591V2.409A2.41,2.41,0,0,1,2.409,0H45.773a2.4,2.4,0,0,1,1.706.7L71.569,24.794a2.4,2.4,0,0,1,.7,1.706V43.364a2.4,2.4,0,0,1-.7,1.706L40.791,75.835,39.072,86.2l10.366-1.718,18.72-18.733a2.417,2.417,0,0,1,4.115,1.706v36.136A2.41,2.41,0,0,1,69.864,106M4.818,101.182H67.455V73.265L52.3,88.433a2.539,2.539,0,0,1-1.317.678L36.525,91.52a2.411,2.411,0,0,1-2.8-2.772l2.409-14.455a2.663,2.663,0,0,1,.678-1.317l30.64-30.605V27.493L44.78,4.818H4.818Z",
    fill: "#583ea0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearedIcon);
export default __webpack_public_path__ + "static/media/cleared_icon.23ed5bfc75aef4618152dbad513394ca.svg";
export { ForwardRef as ReactComponent };